<template>
  <div class="top-nav app-overlay-root" style="width: 100%; height: 0px;" v-bind:class="{'app-overlay-open': showTnC == true || showPrivacy == true || isLoading == true || showScanner == true || embedView !== false}">
    <div class="container-fluid top-nav eemo-yellow" id="nav-top" style="display: none;">
      <div class="row">
        <div class="col-2">
          <div v-if="currentMode==0 && showScanner == false" class="square ic-eemo-square" v-on:click="moveToHome">

          </div>
          <div v-else class="square ic-back" v-on:click="backPressed">

          </div>
        </div>

        <div class="col-8" v-if="showScanner == false">
          <span class="main-title"  id="main-title" v-if="mainTitle != undefined && mainTitle.length > 0">{{mainTitle}}</span>
          <input v-else type="text" class="form-control eemo-gray search-bar text-center" placeholder="Search Restaurant"/>
        </div>
        <div class="col-2" v-if="showScanner == false">
<!--          <div v-if="mainTitle == undefined  || mainTitle.length == 0" class="square clickable-elapsed">-->
<!--            <span><i class="fas fa-search"></i></span>-->
<!--          </div>-->
          <div class="square ic-bill" v-on:click="moveToHistory">

          </div>
        </div>
      </div>

    </div>
    <div class="top-cover nav-padding" v-if="showScanner">
      <div class="text-center" style="margin-top:20px;">
        <img src="https://sj-eemo.s3.ap-northeast-2.amazonaws.com/web/ic-qr-scanner.svg"/>

        <div style="width:300px;color:white;text-align:center;margin-left: auto;margin-right: auto; font-size: 25px;">Scan QR code on table or restaurant</div>
      </div>
      <div class="cam-container" style="margin-top: 20px; padding:10px;">
        <qrcode-stream class="hide" @decode="onDecode"></qrcode-stream>
        <div class="scanner-corner top-left"></div>
        <div class="scanner-corner top-right"></div>
        <div class="scanner-corner bottom-left"></div>
        <div class="scanner-corner bottom-right"></div>
      </div>
    </div>
    <div style="position: fixed; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.6);" v-if="embedView !== false">
      <div style="position: absolute; top: 50%; left: 50%; width: calc(100% - 10px); height: calc(100% - 10px); transform: translate(-50%, -50%);">
        <iframe :src="embedView" title="Thank you" style="width: 100%; height: 100%;"></iframe>
      </div>
    </div>

<!--    <div class="spinner-container" v-if="isLoading">-->
<!--      <div class="spinnermedium">-->
<!--        <span class="bgtopl"><span class="highlighttopl"></span></span>-->
<!--        <span class="bgtopr"><span class="highlighttopr"></span></span>-->
<!--        <span class="bottomrow">-->
<!--          <span class="bgbtml"><span class="highlightbtml"></span></span>-->
<!--          <span class="bgbtmr"><span class="highlightbtmr"></span></span>-->
<!--        </span>-->
<!--      </div>-->
<!--    </div>-->
    <div class="loading-background gif-loading-background" v-if="isLoading">
      <div class="gif-loader">
        <UtensilLoader/>
        <span v-if="loadingMessage">{{loadingMessage}}</span>
      </div>
    </div>
    <transition name="vertical">
    <div class="loading-background" v-if="merchantItem != false && (showTnC == true || showPrivacy == true)">
      <div class="floating-container eemo-gray policy-panel">
        <div class="policy-back">
          <h3><span v-on:click="backPressed"><i class="fas fa-arrow-left"></i></span></h3>
        </div>
        <div class="container policy-body">
          <TnC v-if="showTnC == true" :item="merchantItem"></TnC>
          <OrderPrivacy v-else :item="merchantItem"></OrderPrivacy>
        </div>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
    import {getMyOrder} from "../api/borium";
    import TnC from "./TnC";
    import OrderPrivacy from "./OrderPrivacy";
    import UtensilLoader from "./UtensilLoader";

    require('@/assets/css/styles.css')
    require('@/assets/css/loading.css')
    import Router from '../router';
    import EventBus from "../api/event-bus";
    export default {
        name: "TopNav",
        data() {
            return {
                currentMode:0,
                showScanner: false,
                mainTitle:'',
                isLoading: false,
                loadingMessage:'Please Wait...',
                merchantItem:false,
                showTnC:false,
                showPrivacy:false,
                embedView:false,
            }
        },
        components: {
          TnC,
          OrderPrivacy,
          UtensilLoader,
        },
        created() {
          registerTopBackKeyHandler(this.backPressed);
            EventBus.$on('modeChanged', this.modeChanged);
            EventBus.$on('startScanner', this.startScanner);
            EventBus.$on('setTitle', this.setTitle);
            EventBus.$on('showLoading', this.showLoading);
            EventBus.$on('showTnCs', this.setShowTnc);
            EventBus.$on('showPrivacy', this.setShowPrivacy);
            EventBus.$on('showEmbedView', this.setShowTnc);
        },
        methods: {
            backPressed: function() {
                // console.log("TopNav back pressed");
                if(this.$data.showTnC == true || this.$data.showPrivacy == true) {
                  this.$data.showTnC = false;
                  this.$data.showPrivacy = false;
                  return true;
                }
                if(this.$data.showScanner == true) {
                    this.$data.showScanner = false;
                  // console.log("TopNav back pressed close scanner");
                    return true;
                }
                if(this.$data.showHistory == true) {
                    this.$data.showHistory = false;
                  // console.log("TopNav back pressed close history");
                    return true;
                }
                if(this.$data.embedView !== false) {
                  this.$data.embedView = false;
                }
                return false;
                // EventBus.$emit("backPressed", true);
            },
            moveToHome: function() {
              this.$router.push('/');
            },
            setShowTnc: function(item) {
              this.$data.merchantItem = item;
              this.$data.showPrivacy = false;
              this.$data.showTnC = true;

            },
            setShowPrivacy: function(item) {
              this.$data.merchantItem = item;
              this.$data.showTnC = false;
              this.$data.showPrivacy = true;
            },
            setEmbedView: function(url) {
              this.$data.embedView = url;
            },
            showLoading: function(show, message = 'Please Wait...') {
                this.$data.isLoading = show;
                this.$data.loadingMessage = message;
            },
            modeChanged: function(newMode) {
                this.$data.currentMode = newMode;
            },
            setTitle: function(title) {
                // console.log("setTitle " + title);
                this.$data.mainTitle = title;
            },
            startScanner: function() {
                this.$data.showScanner = true;
            },
            async onDecode(decodedString) {
                // console.log("Decoded String " + decodedString);
                this.$data.showScanner = false;
                // let obj = JSON.parse(decodedString);
                // console.log(obj);
                window.location.href = decodedString;
                // EventBus.$emit("codeScanned", decodedString);
            },
            moveToHistory: function() {
              Router.push('/myorder');
            }



        }
    }
</script>

<style scoped>
  .app-overlay-root.app-overlay-open {
    z-index: 11000;
  }
  .policy-panel {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .policy-back {
    flex: 0 0 auto;
    padding: 10px 20px 0 20px;
    text-align: left;
  }
  .policy-back h3 {
    text-align: left;
    margin: 0;
  }
  .policy-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 16px;
  }
  .top-cover {
    position: fixed;
    width: 100%;
    height: 100%;
    top:0;
    left:0;
    z-index: 1029;
    background-color: rgba(0,0,0,0.8);
  }
  .full-page {
    position: fixed;
    width: 100%;
    height: 100%;
    top:0;
    left:0;
    z-index: 1028;
  }
  .scanner-corner {
    width: 100px;
    height: 100px;
    /*background: red;*/
    position: absolute;
  }
  .top-left {
    top: 0;
    left: 0;
    border-top:2px solid #FFF000;
    border-left:2px solid #FFF000;
  }
  .top-right {
    top:0;
    right:0;
    border-top:2px solid #FFF000;
    border-right:2px solid #FFF000;
  }
  .bottom-left {
    bottom: 0;
    left: 0;
    border-bottom:2px solid #FFF000;
    border-left:2px solid #FFF000;
  }
  .bottom-right {
    bottom: 0;
    right:0;
    border-bottom:2px solid #FFF000;
    border-right:2px solid #FFF000;
  }
</style>



// WEBPACK FOOTER //
// src/components/TopNav.vue